import { render, staticRenderFns } from "./TramosRutasIndex.vue?vue&type=template&id=89629672"
import script from "./TramosRutasIndex.vue?vue&type=script&lang=js"
export * from "./TramosRutasIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports